module.exports = __webpack_public_path__ + "img/icon@3x(5).9d8ade9e.png";